import React, { useState, useContext, useEffect } from 'react'
import { AuthContext } from '../context/AuthContext'
import { NavLink, useLocation } from 'react-router-dom'
//SVG IMAGES
import posts from '../assets/posts.svg'
import postsActive from '../assets/postsActive.svg'
import trades from '../assets/trades.svg'
import tradesActive from '../assets/tradesActive.svg'
import profile from '../assets/profile.svg'
import profileActive from '../assets/profileActive.svg'
import leaderBoard from '../assets/leaderBoard.svg'
import leaderBoardActive from '../assets/leader-assets/leaderBoardActive.svg'
import markets from '../assets/markets.svg'
import marketsActive from '../assets/marketsActive.svg'
//PNG IMAGES
import postsPng from '../assets/posts.png'
import postsPngActive from '../assets/postsActive.png'
import tradesPng from '../assets/trades.png'
import tradesPngActive from '../assets/tradesActive.png'
import profilePng from '../assets/profile.png'
import profilePngActive from '../assets/profileActive.png'
import leaderBoardPng from '../assets/leaderboards.png'
import leaderBoardPngActive from '../assets/leaderboardsActive.png'
import marketsPng from '../assets/markets.png'
import marketsPngActive from '../assets/marketsActive.png'

import '../styles/Footer.css'

const Footer = () => {
  const location = useLocation()
  const { visibleSection, handleSwitchSection } = useContext(AuthContext)
  const [activeTab, setActiveTab] = useState(visibleSection)
  const { isAuthenticated, username } = useContext(AuthContext) // Get the signed-in user
  // Map paths to tab names

  const getTabFromPath = (path) => {
    if (path.startsWith('/leaderboard/')) {
      return 'leaders'
    }

    const pathToTab = {
      '/leaderboards': 'leaders',
      '/all-leaderboards/leaderboards': 'leaders',
      '/all-leaderboards/investors': 'leaders',
      '/all-leaderboards/colleges': 'leaders',
      '/all-leaderboards/college-subgroups': 'leaders',
      '/all-leaderboards/companies': 'leaders',
      '/all-leaderboards/random': 'leaders',
      '/all-leaderboards/high-schools': 'leaders',
      '/all-leaderboards/high-school-subgroups': 'leaders',
      [`/profile/${username}`]: 'profile',
      '/signin': 'profile',
      '/markets': 'markets',
    }
    return pathToTab[path] || visibleSection
  }

  // Determine the active tab using both visibleSection and URL
  useEffect(() => {
    if (getTabFromPath(location.pathname)) {
      const currentTab = getTabFromPath(location.pathname)
      setActiveTab(currentTab)
    } else {
      setActiveTab(visibleSection) // Use visibleSection if available
    }
  }, [visibleSection, location.pathname])

  const handleTabSwitch = (tab) => {
    setActiveTab(tab)
    handleSwitchSection(tab)
  }

  return (
    <div className="FooterContainer">
      <NavLink to="/feed" className="FooterItem">
        <button
          className={`FooterItem ${activeTab === 'posts' ? 'active' : ''}`}
          onClick={() => handleTabSwitch('posts')}
        >
          <img
            src={activeTab === 'posts' ? postsPngActive : postsPng}
            alt="posts"
            className="FooterIcon"
            style={{ width: '20px', height: '20px' }} // Adjust size if necessary
          />
          <span className="FooterText">Posts</span>
        </button>
      </NavLink>
      <NavLink to="/feed" className="FooterItem">
        <button
          className={`FooterItem ${activeTab === 'trades' ? 'active' : ''}`}
          onClick={() => handleTabSwitch('trades')}
        >
          <img
            src={activeTab === 'trades' ? tradesPngActive : tradesPng}
            alt="trades"
            className="FooterIcon"
            style={{ width: '20px', height: '20px' }} // Adjust size if necessary
          />
          <span className="FooterText">Trades</span>
        </button>
      </NavLink>
      <NavLink to="/leaderboards" className="FooterItem">
        <button
          className={`FooterItem ${activeTab === 'leaders' ? 'active' : ''}`}
          onClick={() => handleTabSwitch('leaders')}
        >
          <img
            src={
              activeTab === 'leaders' ? leaderBoardPngActive : leaderBoardPng
            }
            alt="Leaders"
            className="FooterIcon"
            style={{ width: '20px', height: '20px' }} // Adjust size if necessary
          />
          <span className="FooterText">Leaders</span>
        </button>
      </NavLink>
      <NavLink to="/markets" className="FooterItem">
        <button
          className={`FooterItem ${activeTab === 'markets' ? 'active' : ''}`}
          onClick={() => handleTabSwitch('markets')}
        >
          <img
            src={activeTab === 'markets' ? marketsPngActive : marketsPng}
            alt="Leaders"
            className="FooterIcon"
            style={{ width: '20px', height: '20px' }} // Adjust size if necessary
          />
          <span className="FooterText">Markets</span>
        </button>
      </NavLink>
      <NavLink
        to={isAuthenticated && username ? `/profile/${username}` : '/signin'}
        className="FooterItem"
      >
        <button
          className={`FooterItem ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => handleTabSwitch('profile')}
        >
          <img
            src={activeTab === 'profile' ? profilePngActive : profilePng}
            alt="Profile"
            className="FooterIcon"
            style={{ width: '20px', height: '20px' }} // Adjust size if necessary
          />
          <span className="FooterText">Profile</span>
        </button>
      </NavLink>
    </div>
  )
}

export default Footer
